module.exports = __webpack_public_path__ + "img/minus-square.118a6df8.svg";